import { render, staticRenderFns } from "./CarDirectionSupervisorContent.vue?vue&type=template&id=c4ec6dc0&"
import script from "./CarDirectionSupervisorContent.vue?vue&type=script&lang=ts&"
export * from "./CarDirectionSupervisorContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDivider,VRow,VTextField})
